import DOMPurify from "dompurify";
// import { EuiCodeBlock } from "@elastic/eui";

export const parseMarkdown = (md: string): string => {
  let html: any = md;

  html = html.replace(/^#### (.*$)/gim, "<h4>$1</h4>");
  html = html.replace(/^### (.*$)/gim, "<h3>$1</h3>");
  html = html.replace(/^## (.*$)/gim, "<h2>$1</h2>");
  html = html.replace(/^# (.*$)/gim, `<h1>$1</h1>`);

  html = html.replace(/```sql\s*\n([\s\S]*?)```/gi, '<div class="sql">$1</div>');
  // html = html.replace(
  //   /```sql\s*\n([\s\S]*?)```/gi,
  //   (_, code) => `
  // <EuiCodeBlock
  //   language="sql"
  //   isCopyable
  // >
  // ${code.trim()}
  // </EuiCodeBlock>
  // `
  // );
  html = html.replace(/`([^`]+)`/g, `<span class="sql" style="display:inline;">$1</span>`);
  html = html.replace(/\*\*(.*?)\*\*/gim, "<strong>$1</strong>");
  html = html.replace(/^\s*-\s(.*$)/gim, "<li>$1</li>");
  html = html.replace(/@_/g, " ");
  html = html.replace(/_@/g, " ");
  html = html.replace(/@/g, "");
  html = html.replace(/---/g, "");
  html = html.replace(/\n/g, `<div style="height: 16px;"></div>`);
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_, linkText, url) => {
    return `<a href="${url}">[${linkText}]</a>`;
  });

  return html.trim();
};

export const cleanText = (input: string) => {
  return input.replace(/[^a-zA-Z0-9\s.,:;!$%?-]/g, "");
};

export const getThumbUpIcon = (rate: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    className="euiIcon eui-alignMiddle website-css-1t0rgrv-euiIcon-m-isLoaded"
    role="img"
    data-icon-type="thumbUp"
    data-is-loaded="true"
    aria-hidden="true">
    <path d="M4 13H3v-2h1v2Z"></path>
    <path
      fill="var(--primary-color)"
      stroke={rate ? "#1b8dcd" : ""}
      fill-rule="evenodd"
      d="M8.197 1.787a1.135 1.135 0 0 1 1.89-.438 3.222 3.222 0 0 1 .656 3.519L10.26 6h2.738a2 2 0 0 1 1.977 2.308l-.716 4.578A2.5 2.5 0 0 1 11.788 15H8.803a6.457 6.457 0 0 1-2.86-.67A.999.999 0 0 1 5 15H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3a1 1 0 0 1 .943.67A5.012 5.012 0 0 0 7.73 3.206l.467-1.42ZM2 14h3V6H2v8ZM9.372 2.048a.135.135 0 0 0-.225.051L8.68 3.52A6.012 6.012 0 0 1 6 6.827v6.392c.846.507 1.813.78 2.803.78h2.985a1.5 1.5 0 0 0 1.482-1.269l.715-4.577A1 1 0 0 0 12.997 7H9.5a.5.5 0 0 1-.46-.697l.784-1.829a2.222 2.222 0 0 0-.452-2.426Z"
      clip-rule="evenodd"></path>
  </svg>
);

export const getThumbDownIcon = (rate: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    className="euiIcon eui-alignMiddle website-css-1t0rgrv-euiIcon-m-isLoaded"
    role="img"
    data-icon-type="thumbDown"
    data-is-loaded="true"
    aria-hidden="true">
    <path d="M12 7h1v2h-1V7Z"></path>
    <path
      stroke={rate ? "#1b8dcd" : ""}
      fill="var(--primary-color)"
      fill-rule="evenodd"
      d="M7.8 14.22a1.135 1.135 0 0 1-1.89.437 3.221 3.221 0 0 1-.655-3.519l.484-1.132H3.001a2 2 0 0 1-1.977-2.308L1.74 3.12a2.5 2.5 0 0 1 2.47-2.114h2.988c.995 0 1.972.23 2.859.666a.999.999 0 0 1 .941-.666h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-3a1 1 0 0 1-.943-.67A5.012 5.012 0 0 0 8.268 12.8L7.8 14.22Zm6.198-12.214h-3v8h3v-8ZM6.626 13.958c.07.073.193.044.225-.051l.467-1.42a6.012 6.012 0 0 1 2.68-3.309V2.78a5.472 5.472 0 0 0-2.8-.774H4.21a1.5 1.5 0 0 0-1.483 1.269l-.714 4.577A1 1 0 0 0 3 9.006h3.497a.5.5 0 0 1 .46.697l-.784 1.829a2.222 2.222 0 0 0 .452 2.426Z"
      clip-rule="evenodd"></path>
  </svg>
);

export const sanitizeHtml = (html: any, isInput = false) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: isInput ? [] : ["a"],
    ALLOWED_ATTR: isInput ? [] : ["href", "title", "target", "rel"],
    ALLOW_DATA_ATTR: false,
  });
};
